var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "gantt-elastic__chart-row-text-wrapper",
      style: { ..._vm.root.style["chart-row-text-wrapper"] },
      attrs: {
        x: _vm.textConfig.ellipsis
          ? _vm.task.x
          : _vm.task.x +
            _vm.task.width +
            _vm.root.state.options.chart.text.offset,
        y: _vm.task.y - _vm.root.state.options.chart.grid.horizontal.gap,
        width: _vm.getWidth,
        height: _vm.getHeight,
      },
    },
    [
      _c(
        "foreignObject",
        { attrs: { x: "0", y: "0", width: "100%", height: _vm.getHeight } },
        [
          _c(
            "div",
            {
              staticClass: "gantt-elastic__chart-row-text",
              style: {
                ..._vm.root.style["chart-row-text"],
                backgroundColor: _vm.textConfig.ellipsis
                  ? "transparent"
                  : _vm.task.color,
              },
              attrs: { xmlns: "http://www.w3.org/1999/xhtml" },
            },
            [
              _vm.textConfig.render
                ? _c(
                    "div",
                    {
                      staticClass:
                        "gantt-elastic__chart-row-text-content gantt-elastic__chart-row-text-content--text",
                      style: {
                        ..._vm.root.style["chart-row-text-content"],
                        ..._vm.root.style["chart-row-text-content--text"],
                        ..._vm.contentStyle,
                        ..._vm.textConfig.style,
                      },
                    },
                    [
                      _c("Render", {
                        attrs: {
                          render: () =>
                            _vm.textConfig.render(_vm.task.label, _vm.task),
                        },
                      }),
                    ],
                    1
                  )
                : !_vm.html
                ? _c(
                    "div",
                    {
                      staticClass:
                        "gantt-elastic__chart-row-text-content gantt-elastic__chart-row-text-content--text",
                      style: {
                        ..._vm.root.style["chart-row-text-content"],
                        ..._vm.root.style["chart-row-text-content--text"],
                        ..._vm.contentStyle,
                        ..._vm.textConfig.style,
                      },
                    },
                    [_c("div", [_vm._v(_vm._s(_vm.showLabel))])]
                  )
                : _vm.html
                ? _c("div", {
                    staticClass:
                      "gantt-elastic__chart-row-text-content gantt-elastic__chart-row-text-content--html",
                    style: {
                      ..._vm.root.style["chart-row-text-content"],
                      ..._vm.root.style["chart-row-text-content--html"],
                      ..._vm.contentStyle,
                      ..._vm.textConfig.style,
                    },
                    domProps: { innerHTML: _vm._s(_vm.showLabel) },
                  })
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }